import { render, staticRenderFns } from "./Zurueck-button.vue?vue&type=template&id=717612ea"
import script from "./Zurueck-button.vue?vue&type=script&lang=js"
export * from "./Zurueck-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports